import React, { Dispatch } from "react";
import { reducer, initialState } from "./reducer";
import { ProjectsState, ProjectsAction } from "../../types";

type ProjectsContextType = [ProjectsState, Dispatch<ProjectsAction>];

export const ProjectsContext = React.createContext<ProjectsContextType>([
  initialState,
  () => null,
]);

interface ProjectsProviderProps {
  children: React.ReactNode;
}

export const ProjectsProvider: React.FC<ProjectsProviderProps> = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <ProjectsContext.Provider value={[state, dispatch]}>
      {children}
    </ProjectsContext.Provider>
  );
};
